module.exports = __webpack_public_path__ + "img/apps-01.60256316.svg";